import { forwardRef, useState } from "react";

import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PasswordInput = forwardRef<HTMLDivElement, TextFieldProps>(
	function PasswordInput(props, ref) {
		const [visible, setVisible] = useState(false);

		return (
			<TextField
				{...props}
				ref={ref}
				type={visible ? "text" : "password"}
				InputProps={{
					...props.InputProps,
					endAdornment: (
						<InputAdornment position="end">
							<IconButton
								aria-label={visible ? "Ocultar senha" : "Exibir senha"}
								onClick={() => setVisible((current) => !current)}
								onMouseDown={(event) => event.preventDefault()}
								edge="end"
								tabIndex={-1}
							>
								{visible ? <VisibilityOff /> : <Visibility />}
							</IconButton>
						</InputAdornment>
					),
				}}
			/>
		);
	},
);

export default PasswordInput;
